/* eslint-disable no-unused-vars */

import React, { useState } from 'react';
import Lightbox from 'yet-another-react-lightbox';
import 'yet-another-react-lightbox/styles.css';
import { motion, AnimatePresence } from 'framer-motion';
import { Github, Eye, Filter, ExternalLink } from 'lucide-react';
import formatsImage from '../img/annarub.png';
import formatsImg from '../img/formatstest.png';
import carsImage from '../img/cars.png';
import recipeImage from '../img/recipetips.png';
import vacaImage from '../img/vaca.png';
import PowerBi from '../img/PowerBi.png';
import wreckImg from '../img/wreck.png';
import aiImg from '../img/aiImg.png';
import truckImg from '../img/truckImg.png';
import doctorImg from '../img/doctorImg.png';
import myTabs from '../img/myTabs.png';
import bryzImage from '../img/bryz.png';
import medicalVoiceImage from '../img/medical-ai-assistant.png';

import ProjectModal from './ProjectModal';

const Projects = () => {
  const [filter, setFilter] = useState('all');
  const [open, setOpen] = useState(false);
  const [currentIndex, setCurrentIndex] = useState(0);
  const [selectedProject, setSelectedProject] = useState(null);
  const [isModalOpen, setIsModalOpen] = useState(false);

  const projects = [
    {
      id: 15,
      title: "TOGETHER! — Real-Time Cooperative Multiplayer Game",
      description: "Built and deployed a cooperative multiplayer game for 2–6 players with 10 Tiny Heroes adventures and 5 Signal Lost missions. Features real-time synchronization, private clues, shared decisions, and reconnect support.",
      image: "https://raw.githubusercontent.com/ElenkaSan/together-multiplayer-game/main/public/art/share/together-v2.png",
      technologies: ["React", "TypeScript", "Node.js", "Socket.IO", "Vite", "Render"],
      category: "fullstack",
      liveUrl: "https://together-multiplayer-game.onrender.com/",
      githubUrl: "https://github.com/ElenkaSan/together-multiplayer-game",
      featured: true
    },
    {
      id: 14,
      title: "Medical Office — AI Voice Receptionist & Workflow Automation",
      description: "Built an AI voice receptionist for medical-office call routing, staff handoffs, and post-call workflows. Public clean-room demo uses mock providers to demonstrate production orchestration patterns.",
      image: medicalVoiceImage,
      technologies: ["Node.js", "TypeScript", "Fastify", "LiveKit", "OpenAI Realtime", "RingCentral", "n8n"],
      category: "ai",
      liveUrl: "",
      githubUrl: "https://github.com/ElenkaSan/medical-office-ai-voice-receptionist-demo",
      featured: true
    },
    {
      id: 13,
      title: "BRYZ Cleaning Experts — Production Website & AI Concierge",
      description: "Built a production website for a cleaning-service business with an AI concierge and responsive service pages for upholstery and leather care.",
      image: bryzImage,
      technologies: ["React", "Next.js", "TypeScript", "Tailwind CSS", "OpenAI API", "Framer Motion"],
      category: "fullstack",
      liveUrl: "https://bryzcleaning-experts.com/",
      githubUrl: "",
      featured: true
    },
    {
      id: 1,
      title: "Development Center - Formats",
      description: "Full-stack coaching website serving 150+ monthly users with 96% PageSpeed performance score and 100% SEO score. Built from scratch using React, Node.js, PostgreSQL, & Bootstrap.",
      image: formatsImage,
      technologies: ["React", "Node.js", "PostgreSQL", "Bootstrap"],
      category: "fullstack",
      liveUrl: "https://www.formats72.com",
      githubUrl: "#",
      featured: true
    },
    {
      id: 2,
      title: "Development Center - Formats",
      description: "UI/UX designed and developed from scratch the Intelligence Testing System for Formats.",
      image: formatsImg,
      technologies: ["React", "JavaScript", "Tailwind"],
      category: "frontend",
      liveUrl: "https://www.formats-tests.link/",
      githubUrl: "#",
      featured: true
    },
     {
      id: 3,
      title: "Rotor Logistics Inc",
      description: "Transportation & Dispatch: Built a bilingual, UI/UX designed and developed from scratch a bilingual one‑page logistics website with responsive layout, animated sections, and form automation, SEO tooling.",
      image: truckImg,
      technologies: ["Vite", "React", "TypeScript", "Tailwind CSS", "Formspree"],
      category: "frontend",
      liveUrl: "https://rotor-logistics.com",
      githubUrl: "#",
      featured: true
    },
     {
      id: 4,
      title: "K-Pediatrics & Internal Medicine",
      description: "Designed and built a bilingual medical clinic SPA with AI chat and SEO tooling. Shipped a serverless AI chat (OpenAI proxy on Vercel with language detection, emergency guard, quick replies) plus cookie consent.",
      image: doctorImg,
      technologies: ["Vite", "React", "TypeScript", "Tailwind CSS", "Context API (i18n)", "OpenAI API (chat assistant)"],
      category: "frontend",
      liveUrl: "https://www.pediatricadultcare.com/",
      githubUrl: "#",
      featured: true
    },
    {
      id: 5,
      title: "MyTabs – Internal Staff Scheduling for Hospital Departments",
      description: "This app is intended for internal use by healthcare staff only. Access is granted by invitation link provided by your department administrator. If you are not part of an approved department, you will not be able to access any schedules or data.",
      image: myTabs,
      technologies: ["React Native (Expo)", "TypeScript", "StyleSheet", "Supabase (Auth, DB, server functions)", "EAS Build for iOS/Android"],
      category: "fullstack",
      liveUrl: "https://mytabs.dev/",
      githubUrl: "#",
      featured: true
    },
    {
      id: 6,
      title: "Voice-to-ComfyUI Converter",
      description: "AI-powered tool that converts voice commands into ComfyUI workflow configurations. Utilizes OpenAI Whisper for transcription and GPT-4 for generating ComfyUI-compatible JSON structures.",
      image: aiImg,
      technologies: ["Vite", "React", "TypeScript", "Tailwind CSS", "OpenAI Whisper", "GPT-4", "ComfyUI"],
      category: "ai",
      liveUrl: "https://voice-to-comfyui.vercel.app",
      githubUrl: "https://github.com/ElenkaSan/voice-to-comfyui",
      featured: true
    },
    {
      id: 7,
      title: "AI Image Generation Suite",
      description: "Advanced ComfyUI workflows for automated image generation with custom nodes and optimizations. Cloud-based rendering and storage.",
      image: 'https://images.pexels.com/photos/8386440/pexels-photo-8386440.jpeg?auto=compress&cs=tinysrgb&w=800',
      technologies: ["ComfyUI", "Python", "PyTorch", "Flask", "CUDA", "Redis", "Docker"],
      category: "ai",
      liveUrl: "https://ai-image-suite-demo.netlify.app",
      githubUrl: "https://github.com/elenkasan/ai-image-generation-suite",
      featured: true
    },
    {
      id: 8,
      title: "Insurance Analytics Platform – Azure",
      description: "Production-grade 4-notebook analytics pipeline using Azure Databricks, Azure Data Factory, and Power BI. Built customer risk scoring, CLPV, and retention models for 15K+ customers with executive-level dashboards.",
      image: PowerBi,
      technologies: ["Python", "PySpark", "Azure Databricks", "Power BI", "Azure Data Factory"],
      category: "backend",
      liveUrl: "#",
      githubUrl: "https://github.com/ElenkaSan/Insurance_Analytics_Platform",
      featured: true
    },
    {
      id: 9,
      title: "Don't Wreck My House",
      description: "Airbnb-inspired reservation management system with full CRUD functionality and double-booking prevention. Built with Spring Context, JDBC Template, and comprehensive business rules validation.",
      image: wreckImg,
      technologies: ["Java", "Spring Context", "JDBC", "MySQL", "Maven"],
      category: "backend",
      liveUrl: "#",
      githubUrl: "https://github.com/ElenkaSan/Don-t-wreck-my-house",
      featured: true
    },
    {
      id: 10,
      title: "Catch A Ride",
      description: "Full-stack car rental and leasing application with AWS S3 integration, role-based access control, and dynamic form rendering for vehicle management and booking history.",
      image: carsImage,
      technologies: ["Java", "Spring Boot", "React", "MySQL", "AWS S3"],
      category: "fullstack",
      liveUrl: "#",
      githubUrl: "https://github.com/ElenkaSan/Catch-a-ride",
      featured: false
    },
    {
      id: 11,
      title: "Recipe-Tips",
      description: "Healthy lifestyle platform with recipe search, user authentication, workout creation, and food jokes. Features secure backend APIs with Flask WTForm and CSRF security.",
      image: recipeImage,
      technologies: ["Python", "Flask", "SQLAlchemy", "JavaScript", "Bootstrap"],
      category: "fullstack",
      liveUrl: "https://recipe-tips.onrender.com/",
      githubUrl: "https://github.com/ElenkaSan/Capstone_Project_1",
      featured: false
    },
    {
      id: 12,
      title: "Vacation-Time",
      description: "Full-stack responsive application for flight and hotel search with weather checking, trip countdown, and secure JWT authentication with Bcrypt password hashing.",
      image: vacaImage,
      technologies: ["React", "Node.js", "Express", "PostgreSQL", "JWT"],
      category: "fullstack",
      liveUrl: "https://changeable-laugh.surge.sh/",
      githubUrl: "https://github.com/ElenkaSan/Vacation-Front",
      featured: false
    }
  ];

  const categories = [
    { id: 'all', label: 'All Projects' },
    { id: 'fullstack', label: 'Full Stack' },
    { id: 'frontend', label: 'Frontend' },
    { id: 'backend', label: 'Backend' },
    { id: 'ai', label: 'AI & Automation' },
  ];

  const filteredProjects = filter === 'all' 
    ? projects 
    : projects.filter(project => project.category === filter);

  const containerVariants = {
    hidden: { opacity: 0 },
    visible: {
      opacity: 1,
      transition: {
        staggerChildren: 0.1
      }
    }
  };

  const itemVariants = {
    hidden: { opacity: 0, y: 30 },
    visible: { opacity: 1, y: 0 },
    exit: { opacity: 0, y: -30 }
  };

  return (
    <section id="projects" className="projects-section">
      <div className="container">
        <motion.div
          className="section-header"
          initial={{ opacity: 0, y: 30 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6 }}
        >
          <h2>Featured Engineering Projects</h2>
          <p>Showcasing my best work and technical expertise</p>
        </motion.div>

        {/* Filter Buttons */}
        <motion.div
          className="project-filters"
          initial={{ opacity: 0, y: 20 }}
          animate={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, delay: 0.2 }}
        >
          <Filter size={20} />
          {categories.map((category) => (
            <motion.button
              key={category.id}
              className={`filter-btn ${filter === category.id ? 'active' : ''}`}
              onClick={() => setFilter(category.id)}
              whileHover={{ scale: 1.05 }}
              whileTap={{ scale: 0.95 }}
            >
              {category.label}
            </motion.button>
          ))}
        </motion.div>

        {/* Projects Grid */}
        <AnimatePresence mode="wait">
          <motion.div
            className="projects-grid"
            variants={containerVariants}
            initial="hidden"
            animate="visible"
            key={filter}
          >
            {filteredProjects.map((project) => (
              <motion.div
                key={project.id}
                className={`project-card ${project.featured ? 'featured' : ''}`}
                variants={itemVariants}
                layout
                whileHover={{ y: -10 }}
                transition={{ type: "spring", stiffness: 300, damping: 10 }}
                onClick={() => {
                  setSelectedProject(project);
                  setIsModalOpen(true);
                }}
              >
                <div className="project-image">
                  <img src={project.image} alt={project.title} />
                  <div className="project-overlay">
                    <div className="project-actions">
                      {project.liveUrl && project.liveUrl !== '#' && (
                        <motion.a
                          href={project.liveUrl}
                          aria-label={`Visit ${project.title} website (opens in a new tab)`}
                          title="Visit website"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="action-btn"
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Eye size={18} />
                        </motion.a>
                      )}
                      {project.githubUrl && project.githubUrl !== '#' && (
                        <motion.a
                          href={project.githubUrl}
                          aria-label={`View ${project.title} on GitHub (opens in a new tab)`}
                          title="View code on GitHub"
                          target="_blank"
                          rel="noopener noreferrer"
                          className="action-btn"
                          whileHover={{ scale: 1.1 }}
                          whileTap={{ scale: 0.9 }}
                          onClick={(e) => e.stopPropagation()}
                        >
                          <Github size={18} />
                        </motion.a>
                      )}
                    </div>
                  </div>
                </div>

                <div className="project-content">
                  <h3>{project.title}</h3>
                  <p>{project.description}</p>
                  
                  <div className="project-technologies">
                    {project.technologies.map((tech) => (
                      <span key={tech} className="tech-tag">
                        {tech}
                      </span>
                    ))}
                  </div>
                </div>

                {project.featured && (
                  <div className="featured-badge">
                    <span>Featured</span>
                  </div>
                )}
              </motion.div>
            ))}
          </motion.div>
        </AnimatePresence>

        {filteredProjects.length === 0 && (
          <motion.div 
            className="no-projects"
            initial={{ opacity: 0 }}
            animate={{ opacity: 1 }}
          >
            <p>No projects found for this category.</p>
          </motion.div>
        )}
      </div>

      <Lightbox
        open={open}
        close={() => setOpen(false)}
        slides={projects.map(p => ({ src: p.image }))}
        index={currentIndex}
      />

      {selectedProject && (
        <ProjectModal
          project={selectedProject}
          isOpen={isModalOpen}
          onClose={() => setIsModalOpen(false)}
        />
      )}
    </section>
  );
};

export default Projects;
